import { render, staticRenderFns } from "./bankManagement.vue?vue&type=template&id=3cd4b744&scoped=true&"
import script from "./bankManagement.vue?vue&type=script&lang=js&"
export * from "./bankManagement.vue?vue&type=script&lang=js&"
import style0 from "./bankManagement.vue?vue&type=style&index=0&id=3cd4b744&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4b744",
  null
  
)

export default component.exports